<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { hasErrors } from '@utils/form'
import { httpServices } from '@utils/http-services'

export default {
  page: {
    title: 'Create Container',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      users: [],
      groups: [],
      groupId: null,
      image: '',
      imageType: '',
      uploadURL: '',
      orgs: [],
      hardwareIds: [],
      hardwareLocations: [],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getHardwares().then((res) => {
      this.hardwareIds = res.map((i) => i.meta.id)
      this.hardwareLocations = res.map((i) => i.meta.location)
      this.hardwareLocations = [...new Set(this.hardwareLocations)]
    })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/users/getAll', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.users = res.data.Items.map((user, i) => {
          return {
            ...user,
            key: i,
            email: user.pk.replace('USER#', ''),
          }
        })
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/permissions/groups', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.groups = res.data.Items
      })
    axios
      .get(process.env.VUE_APP_KONSUL_API_URL + '/orgs', {
        headers: {
          Authorization: 'Bearer ' + this.$auth.user.access_token,
        },
      })
      .then((res) => {
        this.orgs = res.data.Items
      })
  },
  methods: {
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        if (e.target.result.length > 1000000) {
          return alert('Image is loo large.')
        }
        this.image = e.target.result
        this.imageType = file.type
        this.uploadImage()
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.image = ''
      this.imageType = ''
    },
    uploadImage: async function () {
      // Get the presigned URL
      const response = await axios(
        {
          method: 'GET',
          url: `https://futtqyjl69.execute-api.us-east-1.amazonaws.com/dev/uploads?imageType=${this.imageType}`,
        },
        {
          imageType: this.imageType,
        }
      )
      const binary = atob(this.image.split(',')[1])
      const array = []
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      const blobData = new Blob([new Uint8Array(array)], {
        type: this.imageType,
      })
      const result = await fetch(response.data.uploadURL, {
        method: 'PUT',
        body: blobData,
      })
      if (result) {
        // Final URL for the user doesn't need the query string params
        this.uploadURL = response.data.uploadURL.split('?')[0]
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.image) {
            this.uploadURL =
              'https://s3uploader-s3uploadbucket-bln8n0te4oz.s3.amazonaws.com/6672472.jpg'
          }
          const data = {
            containerId: values.bonfireId,
            orgId: values.orgId,
            meta: {
              name: values.name,
              description: values.description,
              userId: values.userId || [],
              hardwareId: values.hardwareId.toLowerCase(),
              groupId: values.groupId || [],
              os: values.os,
              orgId: values.orgId,
              imageUrl: this.uploadURL,
              location: values.location,
              bonfireId: values.bonfireId,
              toolbar: values.toolbar,
            },
          }

          axios
            .post(process.env.VUE_APP_KONSUL_API_URL + '/containers', data, {
              headers: {
                Authorization: 'Bearer ' + this.$auth.user.access_token,
              },
            })
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'Container'
                  } Successfully Created`,
                })
                this.$router.push({
                  name: 'container-management',
                })
              },
              () => {
                this.$notification.error({
                  message:
                    'Failed to Create Container: That ID already exists.',
                })
              }
            )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/container-management">
              <a-icon type="code" />
              <span>Container Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="plus-square" />
            Add New Container
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="plus-square" style="padding-right: 4px" />
            Add New Container
          </h4>
        </div>

        <template>
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Container Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Name">
                          <a-input
                            v-decorator="[
                              'name',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your name!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Description">
                          <a-input
                            v-decorator="[
                              'description',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your description!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Bonfire ID">
                          <a-input
                            v-decorator="[
                              'bonfireId',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your Bonfire ID!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Location">
                          <a-select
                            v-decorator="[
                              'location',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your location!',
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(h, i) in hardwareLocations"
                              :key="i"
                              :value="h"
                            >
                              {{ h.toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Select an OS">
                          <a-select
                            v-decorator="[
                              'os',
                              {
                                required: true,
                                initialValue: 'Windows',
                              },
                            ]"
                          >
                            <a-select-option :value="'Windows 2016'">
                              Windows 2016
                            </a-select-option>
                            <a-select-option :value="'Windows 2019'">
                              Windows 2019
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Toolbar Active">
                          <a-switch
                            v-decorator="[
                              'toolbar',
                              { valuePropName: 'checked' },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Select a Hardware Id">
                          <a-select
                            v-decorator="[
                              'hardwareId',
                              {
                                rules: [
                                  {
                                    required: true,
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(h, i) in hardwareIds"
                              :key="h + i"
                              :value="h"
                            >
                              {{ h.toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Select an Organization">
                          <a-select
                            v-decorator="[
                              'orgId',
                              {
                                rules: [
                                  {
                                    required: true,
                                  },
                                ],
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(org, i) in orgs"
                              :key="i"
                              :value="org.pk.replace('ORG#', '')"
                            >
                              {{ org.pk.replace('ORG#', '').toUpperCase() }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="groupId">
                          <a-select v-decorator="['groupId']" mode="multiple">
                            <a-select-option
                              v-for="group in groups"
                              :key="group.pk"
                              :value="group.pk"
                            >
                              {{ group.pk.replace('GROUP#', '') }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="userId">
                          <a-select
                            v-decorator="[
                              'userId',
                              {
                                required: true,
                              },
                            ]"
                            mode="multiple"
                          >
                            <a-select-option
                              v-for="user in users"
                              :key="user.key"
                              :value="user.email"
                            >
                              {{ user.email }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="24">
                        <a-form-item label="Profile Image">
                          <div v-if="!image" class="ant-form-item">
                            <input type="file" @change="onFileChange" />
                          </div>
                          <div v-else class="image--container">
                            <img
                              :src="image"
                              style="max-width: 300px; max-height: 300px"
                            />
                            <br /><br />
                            <a-button
                              type="danger"
                              icon="delete"
                              @click="removeImage"
                              >Remove Image
                            </a-button>
                          </div>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel</a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
      </div>
    </div>
  </Layout>
</template>
